<template>
    <div class="project-view">
        <Breadcrumb />
        <div class="project-header">
            <span class="title-watermark">ENGINEERING CASE</span>
            <h1 class="page-title">工程案例</h1>
            <div class="desc">我司奉行"求实、团结、进取、奉献"的企业精神，坚持"客户至上，精诚服务"的理念，自强不息、建造卓越。</div>
        </div>
        <div v-if="loading" class="loading">加载中...</div>
        <div v-else>
            <div v-if="projects.length" class="project-list">
                <div class="project-card" v-for="item in projects" :key="item.id" @click="goDetail(item.id)">
                    <div class="img-wrap">
                        <img :src="fullImageUrl(item.coverImage)" :alt="item.projectName" />
                    </div>
                    <div class="info">
                        <div class="name">{{ item.projectName }}</div>
                    </div>
                </div>
            </div>
            <div v-else class="empty">暂无工程案例</div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import { getAllProjectCases } from '../api/project';
import config from '../config';
export default {
    name: 'ProjectView',
    components: { Breadcrumb },
    data() {
        return {
            projects: [],
            loading: true
        };
    },
    mounted() {
        this.fetchProjects();
    },
    methods: {
        fetchProjects() {
            getAllProjectCases().then(res => {
                if (res.data.code === 200 && Array.isArray(res.data.data)) {
                    this.projects = res.data.data;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        fullImageUrl(path) {
            if (!path) return '';
            if (path.startsWith('http')) return path;
            return config.API_BASE_URL + path;
        },
        goDetail(id) {
            this.$router.push(`/project/${id}`);
        }
    }
};
</script>

<style scoped>
.project-view {
    padding: 32px;
    max-width: 1200px;
    margin: 0 auto;
}

.project-header {
    position: relative;
    text-align: center;
    margin-bottom: 38px;
    margin-top: 8px;
}

.title-watermark {
    position: absolute;
    left: 50%;
    top: -18px;
    transform: translateX(-50%);
    font-size: 2.8rem;
    font-weight: 900;
    color: #1a2a47;
    opacity: 0.09;
    letter-spacing: 0.18em;
    user-select: none;
    pointer-events: none;
    z-index: 1;
    white-space: nowrap;
}

.page-title {
    position: relative;
    z-index: 2;
    text-align: center;
    font-size: 2.1rem;
    font-weight: 700;
    color: #1a2a47;
    margin-bottom: 12px;
    letter-spacing: 1px;
    margin-top: 0;
}

.desc {
    position: relative;
    z-index: 2;
    color: #555;
    font-size: 1.08rem;
    margin-bottom: 0;
    margin-top: 0;
    font-weight: 500;
    letter-spacing: 0.5px;
}

.project-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 32px;
    margin-bottom: 32px;
}

.project-card {
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 24px rgba(30, 60, 120, 0.08);
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.2s, transform 0.2s;
    display: flex;
    flex-direction: column;
    position: relative;
}

.project-card:hover {
    box-shadow: 0 8px 32px rgba(30, 60, 120, 0.16);
    transform: translateY(-4px) scale(1.03);
}

.img-wrap {
    width: 100%;
    aspect-ratio: 16/9;
    background: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.img-wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.project-card:hover .img-wrap img {
    transform: scale(1.06);
}

.info {
    padding: 22px 20px 18px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
}

.name {
    font-size: 1.18rem;
    font-weight: 600;
    color: #1a2a47;
    margin-bottom: 0;
    line-height: 1.3;
    letter-spacing: 0.5px;
}

.loading {
    text-align: center;
    color: #888;
    font-size: 1.1rem;
    margin: 48px 0;
}

.empty {
    text-align: center;
    color: #bbb;
    font-size: 1.1rem;
    margin: 48px 0;
}

@media (max-width: 900px) {
    .project-view {
        padding: 8px;
    }

    .project-list {
        gap: 16px;
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    }

    .info {
        padding: 14px 10px 12px 10px;
    }

    .name {
        font-size: 1rem;
    }

    .title-watermark {
        font-size: 1.3rem;
        top: -8px;
    }

    .page-title {
        font-size: 1.1rem;
    }

    .desc {
        font-size: 0.98rem;
    }
}
</style>